import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { IS_MOBILE_DEVICE } from './config'
import { Helmet } from "react-helmet";

import { parseQuery } from './helpers/queryHelpers'
import { closeErrorModal, setLang } from './actions/acCommon'

import { ErrorModal } from './components/DesignFunctions'
import Landing from './components/Landing'
import DownloadAppsPrompt from './components/DownloadAppsPrompt'
import BookingFlow from './components/BookingFlow'
import Auth from './components/Auth'
import UserPages from './components/UserPages'
import AffiliatePage from './components/AffiliatePage'
import CookieBanner from './components/CookieBanner'

const TERMS = [
	{ label: "aide-menagere-titres-service",   lang: "fr" },
	{ label: "femme-de-menage-titres-service", lang: "fr" },
	{ label: "nettoyer-titres-services",       lang: "fr" },
	{ label: "nettoyage-titres-services",      lang: "fr" },
	{ label: "menage-titres-services",         lang: "fr" },
	{ label: "aide-menagere",                  lang: "fr" },
	{ label: "femme-de-menage",                lang: "fr" },
	{ label: "nettoyer",                       lang: "fr" },
	{ label: "nettoyage",                      lang: "fr" },
	{ label: "menage",                         lang: "fr" },

	{ label: "poetsvrouw-dienstencheque",      lang: "nl" },
	{ label: "huishouden-dienstencheque",      lang: "nl" },
	{ label: "poetshulp-dienstencheque",       lang: "nl" },
	{ label: "kuisvrouw-dienstencheque",       lang: "nl" },
	{ label: "schoonmaken-dienstencheque",     lang: "nl" },
	{ label: "poetsvrouw",                     lang: "nl" },
	{ label: "huishouden",                     lang: "nl" },
	{ label: "poetshulp",                      lang: "nl" },
	{ label: "kuisvrouw",                      lang: "nl" },
	{ label: "schoonmaken",                    lang: "nl" },

	{ label: "cleaning-service-vouchers",      lang: "en" },
	{ label: "house-cleaner-service-vouchers", lang: "en" },
]
/* eslint-disable */
const ZIP_CODE_URLS = TERMS.map(term => "/" + term.label + "/:area(\\d+)-:zone_name")
/* eslint-enable */

class App extends Component {
	state = {
		showCookieBanner: false
	}
	componentDidMount = () => {
		this.checkLanguage()
		this.checkCookiePolicyAcceptance()
	}
	checkCookiePolicyAcceptance = () => {
		let cookiePolicyAccepted = localStorage.getItem('cookiePolicyAccepted')
		if (!cookiePolicyAccepted){
			this.setState({ showCookieBanner: true })
		}
	}
	acceptCookiePolicy = () => {
		localStorage.setItem('cookiePolicyAccepted', true)
		this.setState({ showCookieBanner: false })
	}
	checkLanguage = () => {
		let { location } = this.props
		let urlLabel = location.pathname.split('/')[1]
		let urlLang;
		let urlTerm = TERMS.find(term => term.label === urlLabel)
		if(urlTerm){
			urlLang = urlTerm.lang
		}
		let queryLang = parseQuery(this.props.location.search).lang
		let browserLang = window.navigator.userLanguage || window.navigator.language
		if(typeof browserLang === "string"){
			browserLang = browserLang.substring(0, 2)
		}
		let chosenLang = localStorage.getItem('pootsy-chosen-lang')
		let language = queryLang || chosenLang || urlLang || browserLang
		this.props.dispatch(setLang(language))
	}
	closeErrorModal = () => {
		this.props.dispatch(closeErrorModal())
	}
	render() {
		let { showCookieBanner } = this.state
		let { errors, spinner, auth, lang } = this.props
		document.title = this.context.t("website_title")
		return (
			<div className="App">
				<Helmet>
					<meta name="description" content={this.context.t('meta_description')} />
					<link rel="alternate" href="https://pootsy.be/?lang=en" hreflang="en" />
					<link rel="alternate" href="https://pootsy.be/?lang=nl" hreflang="be-nl" />
					<link rel="alternate" href="https://pootsy.be/?lang=fr" hreflang="be-fr" />
				</Helmet>
				{spinner.show &&
					<div className="spinner">
						{Object.keys(spinner.messages).map(key =>
							<div key={key} className="spinner-message">
							</div>
						)}
					</div>
				}
				{errors.showErrorModal &&
					<ErrorModal
						error={errors.errorMessage}
						localisedError={errors.localisedErrorMessage}
						closeModal={this.closeErrorModal}
					/>
				}
				{showCookieBanner && <CookieBanner acceptCookiePolicy={this.acceptCookiePolicy} lang={lang}/>}
				<Switch>
					<Route path="/auth" component={Auth}/>
					<Route path="/:slug(\d+)-:affiliate_name" component={AffiliatePage}/>
					<Route path="/affiliate-page/:slug" component={AffiliatePage}/>
					{ZIP_CODE_URLS.map(url =>
						<Route key={url} path={url} render={props => <Landing {...props} zipCodeURLs={ZIP_CODE_URLS}/>}/>
					)}
					<Route path="/booking-flow" component={IS_MOBILE_DEVICE ? DownloadAppsPrompt : BookingFlow}/>

					{auth.tokenChecked && auth.signedIn && [
						<Route key="app" path="/app" component={IS_MOBILE_DEVICE ? DownloadAppsPrompt : UserPages}/>,
						<Route key="bookings" path="/bookings" component={UserPages}/>,
						<Route key="bookings_details" path="/bookings/:id" component={UserPages}/>,
						<Route key="affiliate_details" path="/affiliate/:id" component={UserPages}/>,
						<Route key="account" path="/account" component={UserPages}/>
					]}

					<Route path="/" render={props => {
						return <Landing {...props} zipCodeURLs={ZIP_CODE_URLS}/>
					}} />

				</Switch>
			</div>
		);
	}
}

App.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	spinner: state.uiReducer.spinner,
	errors: state.dataReducer.appErrors,
	lang: state.i18nState.lang,
	auth: state.metadataReducer.auth,
})
export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js